﻿export class Location {
    Id: number;
    Name: string;

    constructor() {
        this.Id = 1;
        this.Name = "All Juvenile Locations";
    }
}
